import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';
import swal from 'sweetalert2';

export default {
  revisionListService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'revService',
    'EFeatures',
    function (
      runtimeConstant,
      $http,
      $q,
      $filter,
      webApiSettings,
      Revision,
      EFeatures
    ) {
      'use strict';

      var revisionListServiceFactory = {};

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          var error = {
            status_code: status,
            error: $filter('translate')('SERVER OFFLINE'),
            error_description: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
          return error;
        }

        if (status === 403) {
          var ex1 = {
            status_code: status,
            error: $filter('translate')('REVISION NOT PUBLIC'),
            error_description: $filter('translate')(
              'REVISION NOT PUBLIC DESCRIPTION'
            ),
          };
          return ex1;
        }

        if (status !== 400) {
          var ex = {
            status_code: status,
            error: $filter('translate')('UNEXPECTED ERROR'),
            error_description:
              err !== null && err !== ''
                ? err.toString()
                : $filter('translate')('UNEXPECTED MESSAGE'),
          };
          return ex;
        }
        return err;
      }

      function download(documentId, isPublic, inWorkflow, isDigitalization) {
        var deferred = $q.defer();
        var webApiMethod = 'revisions/file/generate/';

        if (isPublic) {
          webApiMethod = 'revisions/file/public/generate/';
        } else if (inWorkflow) {
          webApiMethod = 'revisions/file/workflow/generate/';
        } else if (isDigitalization) {
          webApiMethod = 'digitalization/file/generate/';
        }

        $http
          .get(webApiSettings.apiServiceBaseUri + webApiMethod + documentId)
          .then((result) => {
            var data = result.data;

            if (isDigitalization)
            {
              top.location.href =
                webApiSettings.apiServiceBaseUri + 'digitalization/file/hash/' + data;
            }
            else
            {
              var queryChar = data.indexOf('?') > -1 ? '&' : '?';
              top.location.href =
                webApiSettings.apiServiceBaseUri + 'revisions/file/hash/' + data + queryChar + 'download=true';
            }

            deferred.resolve(true);
          })
          .catch((err) => deferred.reject(err));

        return deferred.promise;
      }

      function downloadMulti(ids) {
        var deferred = $q.defer();
        var webApiMethod = 'revisions/file/generate/multi';

        $http
          .post(webApiSettings.apiServiceBaseUri + webApiMethod, ids)
          .then((result) => {
            var data = result.data;
            top.location.href = webApiSettings.apiServiceBaseUri + data;
            deferred.resolve(true);
          })
          .catch((data) => deferred.reject(data));

        return deferred.promise;
      }

      function cancelCheckout(documentId) {
        var deferred = $q.defer();
        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'revisions/cancelcheckout/' +
              documentId
          )
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });
        return deferred.promise;
      }

      function checkout(documentId, isHistory) {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'revisions/checkout/' +
              documentId +
              '?isHistory=' +
              (isHistory ? 'true' : 'false')
          )
          .then((result) => {
            var rev = result.data;
            download(rev.Id, false)
              .then(() => deferred.resolve(rev))
              .catch((err) => {
                var error = handleError(err.data, err.status);
                cancelCheckout(documentId)
                  .then(() => deferred.reject(error))
                  .catch(() => deferred.reject(error));
              });
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function doCheckout(rev) {
        swal.fire({
          title: $filter('translate')('WAIT CHECKOUT'),
          text: $filter('translate')('WAIT DOING CHECKOUT'),
          icon: 'info',
          showConfirmButton: false,
        });
        checkout(!rev.isHistory ? rev.id : rev.idRevisionHistory, rev.isHistory)
          .then((data) => {
            rev.revisionCheckout = data.RevisionCheckout;
            rev.idStatus = data.IdStatus;
            rev.updatePermissions();
            swal.close();
          })
          .catch((error) => {
            swal.fire({
              title: error.error,
              text: error.errorDescription,
              icon: 'error',
            });
          });
      }

      function _delete(ids) {
        var deferred = $q.defer();
        $http
          .post(webApiSettings.apiServiceBaseUri + 'revisions/removelist', ids)
          .then(() => deferred.resolve(true))
          .catch((err) => deferred.reject(handleError(err.data, err.status)));
        return deferred.promise;
      }

      function loadSignersInfo(documentId, extension, inWorkflow, isHistory) {
        var deferred = $q.defer();
        var formUri =
          '?isPdf=' +
          (extension === 'pdf') +
          '&inWorkflow=' +
          inWorkflow +
          '&isHistory=' +
          (isHistory ? 'true' : 'false');
        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'revisions/file/signersInfo/' +
              documentId +
              formUri
          )
          .then((result) => deferred.resolve(result.data))
          .catch((err) => deferred.reject(handleError(err.data, err.status)));
        return deferred.promise;
      }

      function move(ids, folderId) {
        var deferred = $q.defer();
        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'revisions/move/' +
              folderId +
              '?ids=' +
              ids.join('&ids=')
          )
          .then(() => deferred.resolve(true))
          .catch((err) => deferred.reject(handleError(err.data, err.status)));
        return deferred.promise;
      }

      function becomeObsolete(revisions) {
        var deferred = $q.defer();

        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'api/v2/revisions/obsolete',
            revisions
          )
          .then(() => deferred.resolve(true))
          .catch((err) => deferred.reject(handleError(err.data, err.status)));

        return deferred.promise;
      }

      function becomeObsoleteIds(ids) {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
            'revisions/obsolete?ids=' +
            ids.join('&ids='))
          .then(() => deferred.resolve(true))
          .catch(err => deferred.reject(_handleError(err.data, err.status)));

        return deferred.promise;
      }

      function reactivate(ids) {
        var deferred = $q.defer();
        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'revisions/reactivate?ids=' +
              ids.join('&ids=')
          )
          .then(() => deferred.resolve(true))
          .catch((err) => deferred.reject(handleError(err.data, err.status)));
        return deferred.promise;
      }

      function favorite(ids) {
        var deferred = $q.defer();
        $http
          .post(webApiSettings.apiServiceBaseUri + 'favorites/add/', ids)
          .then(() => deferred.resolve(true))
          .catch((err) => deferred.reject(handleError(err.data, err.status)));
        return deferred.promise;
      }

      function unfavorite(ids) {
        var deferred = $q.defer();
        $http
          .post(webApiSettings.apiServiceBaseUri + 'favorites/remove/', ids)
          .then(() => deferred.resolve(true))
          .catch((err) => deferred.reject(handleError(err.data, err.status)));
        return deferred.promise;
      }

      function loadLinkedDocuments(ids) {
        var deferred = $q.defer();
        $http
          .post(webApiSettings.apiServiceBaseUri + 'revisions/links/list', ids)
          .then((result) => {
            var data = result.data;
            data = resolveReferences(data);
            var linkedDocs = data.ListLinkedRevisions.map(
              (r) => new Revision(r)
            );

            linkedDocs.unshift(new Revision(data.MainRevision));

            linkedDocs.forEach((ld) => {
              ld.selected = true;
              ld.canDownload = ld.features.includes(EFeatures.DOWNLOAD);
            });

            deferred.resolve(linkedDocs);
          })
          .catch((err) => deferred.reject(handleError(err.data, err.status)));
        return deferred.promise;
      }

      function restore(ids) {
        var deferred = $q.defer();

        $http
          .post(webApiSettings.apiServiceBaseUri + 'revisions/restoreList', ids)
          .then(() => deferred.resolve(true))
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });
        return deferred.promise;
      }

      function deletePermanently(ids) {
        var deferred = $q.defer();
        $http
          .post(
            webApiSettings.apiServiceBaseUri + 'revisions/removeListTrashcan',
            ids
          )
          .then(() => deferred.resolve(true))
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });
        return deferred.promise;
      }

      function hideDocuments(ids) {
        revisionListServiceFactory.documents
          .filter((r) => ids.indexOf(r.id) > -1)
          .forEach((r) => {
            r.removed = true;
          });
      }

      function checkoutOnlyOffice(documentId, isHistory) {
        var deferred = $q.defer();

        $http
          .get(
            webApiSettings.apiServiceBaseUri +
              'revisions/checkout/' +
              documentId +
              '?isHistory=' +
              (isHistory ? 'true' : 'false')
          )
          .then((result) => {
            // Sem chamar download() aqui -- só o lock, o arquivo quem edita é o Document Server
            deferred.resolve(result.data);
          })
          .catch((err) => {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function doCheckoutOnlyOffice(rev) {
        var deferred = $q.defer();

        checkoutOnlyOffice(
          !rev.isHistory ? rev.id : rev.idRevisionHistory,
          rev.isHistory
        )
          .then((data) => {
            rev.revisionCheckout = data.RevisionCheckout;
            rev.idStatus = data.IdStatus;
            rev.updatePermissions();
            deferred.resolve(rev);
          })
          .catch((error) => {
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function getRevisionStatus(idRevision) {
        var deferred = $q.defer();

        $http
          .get(`${webApiSettings.apiServiceBaseUri}revisions/${idRevision}/status`)
          .then((result) => {
            deferred.resolve(result.data);
          })
          .catch((error) => {
            deferred.reject(error);
          });

        return deferred.promise;
      }

      function run() {
        try {
          revisionListServiceFactory.documents = null;

          revisionListServiceFactory.download = logWrapper(
            download,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.downloadMulti = logWrapper(
            downloadMulti,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.cancelCheckout = logWrapper(
            cancelCheckout,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.checkout = logWrapper(
            checkout,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.doCheckout = logWrapper(
            doCheckout,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.loadSignersInfo = logWrapper(
            loadSignersInfo,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.becomeObsolete = logWrapper(
            becomeObsolete,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.reactivate = logWrapper(
            reactivate,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.becomeObsoleteIds = logWrapper(
            becomeObsoleteIds,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.favorite = logWrapper(
            favorite,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.unfavorite = logWrapper(
            unfavorite,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.loadLinkedDocuments = logWrapper(
            loadLinkedDocuments,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.restore = logWrapper(
            restore,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.deletePermanently = logWrapper(
            deletePermanently,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.move = logWrapper(
            move,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.hideDocuments = logWrapper(
            hideDocuments,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.checkoutOnlyOffice = logWrapper(
            checkoutOnlyOffice,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.doCheckoutOnlyOffice = logWrapper(
            doCheckoutOnlyOffice,
            runtimeConstant.isDebugServicesInternals
          );
          revisionListServiceFactory.getRevisionStatus = logWrapper(
            getRevisionStatus,
            runtimeConstant.isDebugServicesInternals
          );

          return revisionListServiceFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
